import { TablePage } from "~/components/Table";
import { IngestionFilters } from "./components/IngestionFilters";
import {
  IngestionSearchRequestProvider,
  IngestionTable,
} from "./components/IngestionTable";

export function IngestionsPage() {
  return (
    <TablePage
      title="Search Ingestions"
      RequestProvider={IngestionSearchRequestProvider}
      table={<IngestionTable />}
      filters={<IngestionFilters />}
    />
  );
}
